import InnerContainer from "@/components/ContentContainer/InnerContainer";
import Skeleton from "@/components/Skeleton/Skeleton";
import { useGetMaterial } from "../useMaterials";
import styles from "./MaterialDetail.module.scss";
import ProductRelationsPerYearTable from "./MaterialProductsPerYearTable";
import MaterialRelatedProductsTable from "./MaterialRelatedProductsTable";

export default function MaterialRelations({ materialId }: { materialId: number }) {
  const { data, isLoading } = useGetMaterial({ materialId });

  return (
    <InnerContainer
      title="Relations"
      borderTop={true}
      contentClassName={styles.MaterialRelations}
    >
      <div className={[styles.relation, styles.products].join(" ")}>
        <div>
          <h3>Products</h3>
          <span className={styles.metric}>
            <Skeleton
              loading={isLoading}
              style={{ width: 20, height: 24 }}
            >
              {data?.relations}
            </Skeleton>
          </span>
        </div>
      </div>
      <ProductRelationsPerYearTable materialId={materialId} />
      <MaterialRelatedProductsTable materialId={materialId} />
    </InnerContainer>
  );
}
